import { useEffect, useState } from "react";

const useAnimatedCount = (target, active = true) => {
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!active || target == null || Number.isNaN(target)) {
      setDisplay(0);
      return undefined;
    }

    const numericTarget = Number(target);
    let start = 0;
    const duration = 1200;
    let frameId;

    const step = (timestamp) => {
      if (!start) start = timestamp;
      const progress = Math.min((timestamp - start) / duration, 1);
      setDisplay(Math.floor(progress * numericTarget));
      if (progress < 1) {
        frameId = requestAnimationFrame(step);
      }
    };

    frameId = requestAnimationFrame(step);
    return () => cancelAnimationFrame(frameId);
  }, [target, active]);

  return display;
};

export const formatCount = (value) => Number(value || 0).toLocaleString();

export default useAnimatedCount;
